export function getCookie(name) {
  const cookies = document.cookie.split(';').map((cookie) => cookie.trim())
  const cookie = cookies.find((cookie) => cookie.startsWith(`${name}=`))
  return cookie ? cookie.split('=')[1] : ''
}

export function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 86400000).toUTCString() // 86400000 = 1 day
  document.cookie = `${name}=${value}; expires=${expires}; path=/`
}
